import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';

export default function Blog() {
  const [expanded, setExpanded] = useState(false);

  const paragraphs = [
    "Some journeys don’t begin with a plan — they begin with a spark. For me, that spark ignited not behind the camera, but in front of it.",
    "In December 2019, as I stood on the stage of Mr. Inaruwa, receiving the Runner-Up title, I didn’t realize that moment would become the catalyst for discovering my true passion — photography. What began as a model expanding his portfolio slowly evolved into a love affair with light, emotion, and storytelling through the lens.",
    "Behind the camera, I found something more than just angles and exposure — I found meaning. I began studying the play of ISO, Shutter Speed, and Aperture like an artist discovering color for the first time. Each frame became a way to preserve emotion, freeze a fleeting second, or whisper a story words could never fully express.",
    "With every photoshoot I attended, I was no longer just the subject. I was becoming the observer — curious, inspired, and driven. The turning point came when I picked up a camera and realized this was more than curiosity — it was calling. Guided by generous mentors and my brother, Sushant Raman Pokhrel, who introduced me to the magical art of photo editing, I started building not just skills, but a vision.",
    "Though I initially searched for a second-hand camera within reach, my family — believing in my dream more than I did — gifted me a brand-new Canon 80D DSLR. That moment didn’t just give me a tool; it gave me wings.",
    "Since then, I’ve explored life through my viewfinder — capturing raw emotion, unnoticed beauty, and stories waiting to be told. My photography is not just a portfolio; it’s a collection of moments that speak louder than words ever could.",
    "Today, every click is a silent promise to stay present, stay curious, and stay connected. Because photography, for me, is more than a craft — it’s how I feel the world."
  ];

  return (
    <section className="py-20 px-4 md:px-8 bg-gradient-to-b from-gray-800 to-gray-900 text-white">
      <div className="max-w-4xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-4xl font-bold mb-12 text-center bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-pink-600"
        >
          My Photography Journey
        </motion.h2>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="bg-gray-800 rounded-lg shadow-lg p-8 relative overflow-hidden"
        >
          <h3 className="text-2xl font-semibold mb-6 text-center text-gray-300">If you know me, you know my story.</h3>
          <div className="space-y-6 text-gray-300 leading-relaxed">
            <p className="text-justify">{paragraphs[0]}</p>
            <AnimatePresence>
              {expanded && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  {paragraphs.slice(1).map((paragraph, index) => (
                    <p key={index} className="mt-4 text-justify">{paragraph}</p>
                  ))}
                </motion.div>
              )}
            </AnimatePresence>
          </div>
          <div className="flex justify-center mt-8">
            <button
              className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-lg flex items-center justify-center transition-colors duration-300"
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? (
                <>
                  Read Less
                  <ChevronUp className="ml-2" size={20} />
                </>
              ) : (
                <>
                  Read More
                  <ChevronDown className="ml-2" size={20} />
                </>
              )}
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
